import React, { useEffect } from 'react';
import { Form, Input, Select, Row, Col, DatePicker } from 'antd';
import NATION_OPTIONS from "../../../config/nations";
import feeService from '../../../services/fee';
const { Option } = Select;

interface OtherBusinessTabProps {
  serviceType: string;
  getReadOnlyProps?: (fieldType?: 'input' | 'select') => any;
  baseCountryMode?: boolean;
  hideSubService?: boolean;
}


// 其他业务信息 Tab：从 DynamicOrderForm 中的内联 OtherInfo 提取
const OtherSection: React.FC<OtherBusinessTabProps> = ({ serviceType, getReadOnlyProps = () => ({}), baseCountryMode = false, hideSubService = false }) => {
  const formInstance = Form.useFormInstance();
  const watchedNation = Form.useWatch('nation', formInstance);

  useEffect(() => {
    const loadChannels = async () => {
      try {
        if (!watchedNation) {
          return;
        }
        await feeService.getSubmitChannelsByNation(watchedNation as string);
      } catch (e) {
        // ignore
      }
    };
    loadChannels();
  }, [watchedNation]);
  return (
    <>

      {hideSubService ? (
        <Form.Item name="sub_service" initialValue={formInstance.getFieldValue('sub_service') || 'registration'} hidden>
          <Input type="hidden" />
        </Form.Item>
      ) : (
        <Form.Item label="子业务名称" name="sub_service" rules={[{ required: true, message: '请选择子业务名称' }]}>
          <Select placeholder="请选择子业务名称">
            <Option value="registration">其他注册业务</Option>
            <Option value="cancellation">其他注销业务</Option>
          </Select>
        </Form.Item>
      )}

      <Form.Item
        label={baseCountryMode ? '基础国家/地区' : '国家/地区'}
        name="nation"
        rules={[{ required: true, message: baseCountryMode ? '请选择基础国家/地区' : '请选择国家/地区' }]}
      >
        <Select
          placeholder={baseCountryMode ? '请选择基础国家/地区' : '请选择国家/地区'}
          showSearch
          filterOption={(input, option) =>
            String(option?.children || '').toLowerCase().includes(input.toLowerCase())
          }
          data-testid="order-nation"
        >
          {NATION_OPTIONS.map(option => (
            <Select.Option key={option.value} value={option.value}>
              {option.label}
            </Select.Option>
          ))}
        </Select>
      </Form.Item>

      <Row gutter={16}>
        <Col span={24}>
          <Form.Item label="订单编号" name="order_no" rules={[{ required: true, message: '订单编号自动生成' }]}>
            <Input placeholder="自动生成" readOnly style={{ backgroundColor: '#f5f5f5', color: '#999' }} data-testid="order-no" />
          </Form.Item>
        </Col>
      </Row>

      <Form.Item label="业务名" name="service_name" rules={[{ required: true, message: '请输入业务名' }]}>
        <Input placeholder="请输入业务名" data-testid={"order-other-service-name"} />
      </Form.Item>

      <Form.Item label="备注" name="remark">
        <Input.TextArea rows={3} placeholder="请输入备注信息" data-testid="order-remark" />
      </Form.Item>

      <Form.Item label="截止日期" name="due_at">
        <DatePicker style={{ width: '100%' }} placeholder="请选择截止日期" data-testid="order-due-at" />
      </Form.Item>
    </>
  );
};

export default OtherSection;
